import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const arrayValidator = ({ element, requiredError, minLength, maxLength, length, conditions, }) => {
    let validator = z.array(element, {
        error: createErrorHandler(requiredError),
    });
    if (minLength) {
        validator = validator.min(minLength.min, minLength.error);
    }
    if (maxLength) {
        validator = validator.max(maxLength.max, maxLength.error);
    }
    if (length) {
        validator = validator.length(length.len, length.error);
    }
    for (const { cond, error } of conditions ?? []) {
        validator = validator.refine(cond, error);
    }
    return validator;
};
